/** @format */
import { useTranslation } from 'next-i18next';

import {
    SortByOption,
    SortDirection,
} from '@toucan/client/features/search/config/types';

import { UseProductSortOptionsReturn } from './types';

export const useProductSortOptions = (): UseProductSortOptionsReturn => {
    const { t } = useTranslation();

    const sortOptions: SortByOption[] = [
        {
            title: t('Price high to low', { context: 'sortOptions' }),
            value: 'price_high_low',
            facet: 'product_price',
            direction: SortDirection.DESC,
        },
        {
            title: t('Price low to high', { context: 'sortOptions' }),
            value: 'price_low_high',
            facet: 'product_price',
            direction: SortDirection.ASC,
        },
        {
            title: t('Newly listed', { context: 'sortOptions' }),
            value: 'product_last_online',
            facet: 'product_last_online',
            direction: SortDirection.DESC,
        },
    ];

    return { sortOptions, defaultSortOption: sortOptions[0] };
};
